import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$workspaceId/projects/$channelId/chats")(
	{
		component: () => {
			return <div>{Route.path}</div>;
		},
	},
);
